import styled from 'styled-components'
import { breackpoints, cores } from '../../styles'

export const Modal = styled.div`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;

  &.is-visible {
    display: flex;
  }
`

export const Overlay = styled.div`
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  background-color: ${cores.preto};
  opacity: 0.7;
`

export const ModalContainer = styled.div`
  max-width: 1024px;
  width: 100%;
  background-color: ${cores.branco};
  border-radius: 6px;

  header {
    display: flex;
    justify-content: right;
    padding: 15px;
    border-bottom: 2px solid ${cores.cinza};

    p {
      color: ${cores.vermelho};
      font-size: 25px;
      font-weight: bold;
      cursor: pointer;
    }
  }

  body {
    display: flex;
    justify-content: center;
    padding: 50px;

    img {
      border-radius: 6px;
    }
  }

  @media (max-width: ${breackpoints.desktop}) {
    max-width: 780px;
    img {
      width: 100%;
    }
  }

  @media (max-width: ${breackpoints.tablet}) {
    max-width: 360px;
  }
`
